import React from "react";
import "./UserPreviewCard.css";

export default function UserPreviewCard({ user }) {
  if (!user) return null;

  // 👇 Corrigido — inclui verifySelfieUrl
  const imageSrc =
    user.photoURL ||
    user.foto ||
    user.profileImage ||
    user.imageUrl ||
    user.verifySelfieUrl || // ✅ Novo campo do Firestore
    "/default-avatar.png";

  return (
    <div className="user-preview-card">
      <img src={imageSrc} alt={user.name} />
      <div className="user-info">
        <h4>{user.name}</h4>
        <p>{user.city || "Cidade não informada"}</p>
        <p className="user-plan">
          Plano: <strong>{user.plan || "Free"}</strong>
        </p>
      </div>
    </div>
  );
}
